// @flow

import React from 'react';
import type { Node } from 'react';
import queryString from 'query-string';
import { Link } from '@riseart/common';
import { setTimeToDate } from 'shared_services/riseart/utils/Utils';

type Props = {
  name: ?string,
  startDate: ?string | ?Date,
  endDate: ?string | ?Date,
  startTime: ?string | ?Date,
  endTime: ?string | ?Date,
  details: ?string,
  location: ?string,
  linkProps?: ?Object,
  children: Node | Function,
};

/**
 * convertToCalendarDate
 *
 * @param {string | Date} date
 * @param {string | Date} time
 * @returns {string}
 */
const convertToCalendarDate = (date: string | Date, time: string | Date): string => {
  return setTimeToDate(date, time)
    .toISOString()
    .replace(/-|:|\.\d\d\d/g, '');
};

/**
 * generateCalendarUrl
 *
 * @param {Object} props
 * @returns {string}
 */
const generateCalendarUrl = ({
  name,
  startDate,
  endDate,
  startTime,
  endTime,
  details,
  location,
}: Object): string => {
  const BASE_URL = 'https://www.google.com/calendar/render';
  const queryParams = {
    action: 'TEMPLATE',
    text: name,
    dates:
      startDate && endDate
        ? `${convertToCalendarDate(startDate, startTime)}/${convertToCalendarDate(
            endDate,
            endTime,
          )}`
        : null,
    details,
    location,
    sf: true,
    output: 'xml',
  };

  return `${BASE_URL}?${queryString.stringify(queryParams)}`;
};

/**
 * EmbeddedGoogleCalendarLink
 *
 * @param {Props} props
 */
export const EmbeddedGoogleCalendarLink = ({
  children,
  linkProps = null,
  ...restProps
}: Props): Node => {
  const url = generateCalendarUrl(restProps);

  return typeof children === 'function' ? (
    children(url)
  ) : (
    <Link external target="_blank" href={url} {...linkProps}>
      {children}
    </Link>
  );
};
